const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_auth/sign-in/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { SignInSearchSchema } from '@apps/main/features/auth/pages/sign-in-schema';
import { redirectIfLoggedIn } from '@apps/main/lib/route-guards';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_auth/sign-in')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: SignInSearchSchema,
  beforeLoad: ({
    location
  }) => redirectIfLoggedIn(location)
});